var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Principal',_vm._b({},'Principal',_vm.principal,false)),_c('Secundario',_vm._b({},'Secundario',_vm.about,false)),_c('Features',_vm._b({},'Features',_vm.feature,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }